import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { shortTitleSelector } from 'selectors/indicator/index';
import {
  usSelector,
  snapshotSelector,
} from 'selectors/indicator/usSnapshot';
import { timeframeLatest } from 'selectors/indicator/timeframe';
import { hover as hoverColor } from 'config/colors';

// Components
import SnapshotCallout from 'components/snapshotCallout';
import SnapshotLegend from 'components/snapshotLegend';

// Styles
import styles from './usSnapshotMap.scss';

class UsSnapshotMap extends Component {
  constructor() {
    super();

    this.state = {
      activeHover: null,
    };
    this.onHover = this.onHover.bind(this);
  }

  onHover(e) {
    this.setState({ activeHover: e });
  }

  render() {
    const {
      title,
      timeframe,
      unitedStates,
      data,
    } = this.props;

    const { activeHover } = this.state;

    return (
      <figure className={styles.usSnapshotMap}>
        <div
          className={styles.map}
        >
          <div className={styles.responsiveWrapper}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 939 588"
              preserveAspectRatio="xMinYMin meet"
            >
              <g id="outlines">
                {data.map((datum) => {
                  const { d, color, geography } = datum;
                  const isActive = this.state.activeHover &&
                    this.state.activeHover.geography === geography;

                  return (<path
                    d={d}
                    key={geography}
                    fill={isActive ? hoverColor : color}
                    onMouseOver={() => this.onHover(datum)}
                    onFocus={() => this.onHover(datum)}
                  />);
                })}
              </g>
            </svg>
          </div>
        </div>
        <figcaption className={styles.callout}>
          <SnapshotCallout
            geography="United States"
            value={unitedStates.value}
            year={timeframe}
            label={title}
          />
          { activeHover && (
            <SnapshotCallout
              geography={activeHover.name}
              value={activeHover.value}
              year={timeframe}
              label={title}
            />
          ) }
          <SnapshotLegend data={data} />
        </figcaption>
      </figure>
    );
  }
}

UsSnapshotMap.propTypes = {
  title: PropTypes.string.isRequired,
  timeframe: PropTypes.string.isRequired,
  unitedStates: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
  }).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      d: PropTypes.string.isRequired,
      geography: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]).isRequired,
      color: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};

const mapStateToProps = (state) => ({
  title: shortTitleSelector(state),
  unitedStates: usSelector(state),
  timeframe: timeframeLatest(state).label,
  data: snapshotSelector(state),
});

export default connect(mapStateToProps)(UsSnapshotMap);



// WEBPACK FOOTER //
// ./app/components/usSnapshotMap/index.js